<template>
    <div class="ObjectParams">
        <div class="ObjectParams__item" v-for="(param, paramName) of params" :key="paramName">
            <img :src="getParamDescriptionByName(paramName).icon" :alt="paramName" v-if="param">
            <div class="ObjectParams__text"  v-if="param">{{param}}</div>
        </div>
    </div>
</template>

<script>
import {getParamDescriptionByName} from '@/utils/getParamDescriptionByName'
export default {
    name: "ObjectParams",
    props: {
        params: Object,
    },
    methods: {
        getParamDescriptionByName
    }
}
</script>

<style lang="scss">
.ObjectParams {

  &__item {
    display: flex;
    align-items: center;

    & + & {
      margin-top: 12px;

      @include mobile {
        margin-top: 8px;
      }
    }
  }

  &__text {
    margin-left: 12px;
  }
}
</style>